import { useEffect } from 'react';
import { UserManager } from 'oidc-client-ts';
import { createAuthConfig } from '../authConfig';

export function LogoutCallback() {
  useEffect(() => {
    const handleLogoutCallback = async () => {
      try {
        const userManager = new UserManager(createAuthConfig());
        // Process the signout response from the OIDC provider
        await userManager.signoutCallback();
      } catch (error) {
        console.error('Logout callback error:', error);
      }
      // Redirect to home - ProtectedRoute will handle login if needed
      window.location.href = '/';
    };

    handleLogoutCallback();
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh' 
    }}>
      <span>Signing out...</span>
    </div>
  );
}
